import React from 'react';

const NavigationButtons = () => (
  <div className="flex flex-wrap justify-between mt-10 mb-12 mx-4 sm:mx-16 bg-transparent">
    <div className="w-full sm:w-1/3 flex justify-center mb-4 sm:mb-0">
      <button
        className="w-3/4 sm:w-3/4 p-4 bg-gradient-to-r from-gray-700 to-gray-900 text-white text-lg font-semibold rounded-xl cursor-pointer transition-all duration-300 hover:from-gray-800 hover:to-gray-950 hover:shadow-xl transform hover:scale-105 shadow-lg border border-gray-600"
        onClick={() => window.location.href = '/'}
      >
        <span className="flex items-center justify-center space-x-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span>Volver</span>
        </span>
      </button>
    </div>
    <div className="w-full sm:w-1/3 flex justify-center mb-4 sm:mb-0">
      <button
        className="w-3/4 sm:w-3/4 p-4 bg-gradient-to-r from-gray-600 to-gray-800 text-white text-lg font-semibold rounded-xl cursor-pointer transition-all duration-300 hover:from-gray-700 hover:to-gray-900 hover:shadow-xl transform hover:scale-105 shadow-lg border border-gray-500"
        onClick={() => window.location.href = 'https://forms.gle/65j3no9SxuKJUeA2A'}
      >
        <span className="flex items-center justify-center space-x-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
          <span>Cotizá tu auto</span>
        </span>
      </button>
    </div>
    <div className="w-full sm:w-1/3 flex justify-center">
      <button
        className="w-3/4 sm:w-3/4 p-4 bg-gradient-to-r from-gray-600 to-gray-800 text-white text-lg font-semibold rounded-xl cursor-pointer transition-all duration-300 hover:from-gray-700 hover:to-gray-900 hover:shadow-xl transform hover:scale-105 shadow-lg border border-gray-500"
        onClick={() => window.location.href = 'https://walink.co/f717a6'}
      >
        <span className="flex items-center justify-center space-x-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          <span>Contacto</span>
        </span>
      </button>
    </div>
  </div>
);

export default NavigationButtons;